import * as React from 'react';

import type { IconProps } from '../types';

const StatusClover = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M7.99999 7.99951L10.0607 11.5688C10.9766 13.1552 9.83177 15.1382 7.99999 15.1382C6.1682 15.1382 5.02334 13.1552 5.93923 11.5688L7.99999 7.99951Z"
        />
        <path
          fill="currentColor"
          d="M7.99999 7.99951L11.5693 5.93875C13.1557 5.02286 15.1387 6.16773 15.1387 7.99951C15.1387 9.8313 13.1557 10.9762 11.5693 10.0603L7.99999 7.99951Z"
        />
        <path
          fill="currentColor"
          d="M7.99999 7.99951L10.0607 4.43018C10.9766 2.8438 9.83177 0.86084 7.99999 0.86084C6.1682 0.86084 5.02334 2.8438 5.93923 4.43018L7.99999 7.99951Z"
        />
        <path
          fill="currentColor"
          d="M7.99999 7.99951L4.43066 5.93875C2.84429 5.02286 0.861328 6.16773 0.861328 7.99951C0.861328 9.8313 2.84429 10.9762 4.43066 10.0603L7.99999 7.99951Z"
        />
      </svg>
    );
  }
);

StatusClover.displayName = 'StatusClover';

export { StatusClover };
